import React from 'react';
import { motion } from 'framer-motion';
import { Language } from '../App';
import { PageHero } from '../components/PageHero';
interface TeamProps {
  language: Language;
}
export function Team({
  language
}: TeamProps) {
  const isPashto = language === 'pashto';
  const teamMembers = [{
    nameEn: 'Dr. Ahmad Ali',
    namePs: 'ډاکټر احمد علي',
    roleEn: 'Editor in Chief',
    rolePs: 'مسؤل مدیر',
    locationEn: 'Mardan, Pakistan',
    locationPs: 'مردان، پاکستان',
    bioEn: 'Founder of Pasoon with over 30 years of experience in Pashto literature.',
    bioPs: 'د پاڅون بنسټ ایښودونکی چې په پښتو ادب کې تر ۳۰ کلونو ډیره تجربه لري.'
  }, {
    nameEn: 'Zarmina Khan',
    namePs: 'زرمینه خان',
    roleEn: 'Poetry Editor',
    rolePs: 'د شعرونو مدیره',
    locationEn: 'Kabul, Afghanistan',
    locationPs: 'کابل، افغانستان',
    bioEn: 'Award-winning poet and critic specializing in contemporary Pashto verse.',
    bioPs: 'جایزه ګټونکې شاعره او نقاده چې په معاصر پښتو شعر کې تخصص لري.'
  }, {
    nameEn: 'Tariq Rahman',
    namePs: 'طارق رحمان',
    roleEn: 'Academic Editor',
    rolePs: 'علمي مدیر',
    locationEn: 'London, UK',
    locationPs: 'لندن، انګلستان',
    bioEn: 'Linguist focused on the preservation of Pashto dialects in the diaspora.',
    bioPs: 'ژبپوه چې په بهر کې د پښتو لهجو په ساتنه تمرکز کوي.'
  }];
  return <div className="pt-24 md:pt-28" data-id="element-660">
      <PageHero language={language} titleEn="The Team" titlePs="زموږ ټیم" introEn="Meet the dedicated editors and writers behind Pasoon magazine." introPs="د پاڅون مجلې تر شا د وقف شویو مدیرانو او لیکوالانو سره وپیژنئ." data-id="element-661" />

      <section className="py-8 bg-white px-6" data-id="element-662">
        <div className="max-w-6xl mx-auto" data-id="element-663">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-664">
            {teamMembers.map((member, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-gray-50 rounded-2xl overflow-hidden border border-gray-100" data-id="element-665">
                <div className="h-48 bg-pasoon-red/10 flex items-center justify-center" data-id="element-666">
                  {/* Placeholder for profile image */}
                  <div className="w-24 h-24 rounded-full bg-pasoon-red/20 border-4 border-white flex items-center justify-center text-pasoon-red text-2xl font-bold" data-id="element-667">
                    {isPashto ? member.namePs.charAt(0) : member.nameEn.charAt(0)}
                  </div>
                </div>
                <div className="p-6 text-center" data-id="element-668">
                  <h3 className={`text-xl font-bold text-pasoon-dark mb-1 ${isPashto ? 'font-pashto' : 'font-serif'}`} data-id="element-669">
                    {isPashto ? member.namePs : member.nameEn}
                  </h3>
                  <p className={`text-pasoon-red font-medium text-sm mb-2 ${isPashto ? 'font-pashto' : ''}`} data-id="element-670">
                    {isPashto ? member.rolePs : member.roleEn}
                  </p>
                  <p className={`text-gray-400 text-xs mb-4 ${isPashto ? 'font-pashto' : ''}`} data-id="element-671">
                    {isPashto ? member.locationPs : member.locationEn}
                  </p>
                  <p className={`text-gray-600 text-sm ${isPashto ? 'font-pashto leading-loose' : 'leading-relaxed'}`} data-id="element-672">
                    {isPashto ? member.bioPs : member.bioEn}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}